"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanLinkModal = void 0;
exports.openSpanLinkModal = openSpanLinkModal;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const modal_service_1 = require("../../components/modal/modal.service");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const collection_view_style_1 = require("../collection.view/collection.view.style");
const collection_view_subform_1 = require("../collection.view/collection.view.subform");
const span_link_modal_style_1 = require("./span.link.modal.style");
const span_link_modal_state_1 = require("./span.link.modal.state");
const readonly_collection_view_ctrl_1 = require("./readonly.collection.view.ctrl");
(0, theme_1.addStyles)(span_link_modal_style_1.Style);
/**
 * Modal for selecting a span to link to on the target collection.
 * Shows a split panel with span list on the left and preview on the right.
 */
class SpanLinkModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, state) {
        super(ctx);
        this.state = state;
        this.readonlyCtrl = new readonly_collection_view_ctrl_1.ReadonlyCollectionViewCtrl();
        // Disable submit button when nothing selected
        this.autorun(() => {
            this.isSubmitButtonDisabled = !this.state.canSubmit;
        });
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.container }, [this.viewLeftPanel(), this.viewRightPanel()]);
    }
    viewLeftPanel() {
        return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.leftPanel }, [
            (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.panelTitle }, (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_SELECT_SPAN_TITLE)),
            this.viewSpanList(),
            (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.panelFooter }, [(0, mithril_1.m)('a', (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_LEARN_MORE))]),
        ]);
    }
    viewCreateNewOption() {
        // Don't show create new if there's an existing link to source
        if (this.state.hasExistingLinkToSource) {
            return null;
        }
        const isSelected = this.state.createNewSpan;
        const inputId = 'span-link-create-new';
        return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.createNewOption }, [
            (0, mithril_1.m)('input', {
                type: 'radio',
                id: inputId,
                name: 'span-selection',
                checked: isSelected ? 'checked' : null,
                onchange: () => this.state.selectCreateNew(),
            }),
            (0, mithril_1.m)('label', { for: inputId }, '+ ' + (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_CREATE_NEW)),
        ]);
    }
    viewSpanList() {
        const spans = this.state.availableSpans;
        return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.spanList }, [
            ...spans.map((item) => this.viewSpanItem(item)),
            this.viewCreateNewOption(),
        ]);
    }
    viewSpanItem(item) {
        const isSelected = this.state.selectedSpanId === item.instanceId;
        const inputId = `span-link-item-${item.instanceId}`;
        // Use the span color for the left border, default to transparent if no color
        const borderColor = item.color || 'transparent';
        return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.spanItem }, [
            (0, mithril_1.m)('input', {
                type: 'radio',
                id: inputId,
                name: 'span-selection',
                checked: isSelected ? 'checked' : null,
                onchange: () => this.state.selectSpan(item.instanceId),
            }),
            (0, mithril_1.m)('label', {
                for: inputId,
                style: { 'border-left-color': borderColor },
            }, item.title + (item.spanType ? ` (${item.spanType})` : '')),
        ]);
    }
    viewRightPanel() {
        const selectedSpan = this.state.selectedSpan;
        if (!selectedSpan && !this.state.createNewSpan) {
            return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.rightPanel }, [
                (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.previewEmpty }, (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_SELECT_SPAN)),
            ]);
        }
        if (this.state.createNewSpan) {
            return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.rightPanel }, [
                (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.previewEmpty }, (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_NEW_SPAN_INFO)),
            ]);
        }
        const instance = this.state.selectedSpanInstance;
        if (!instance) {
            return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.rightPanel }, [(0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.previewEmpty }, 'Error loading span')]);
        }
        return (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.rightPanel }, (0, mithril_1.m)('div', { className: span_link_modal_style_1.CSS.previewContainer }, this.viewSpanInstance(instance)));
    }
    /**
     * Renders the span instance with header (matching CollectionEditViewSubform.viewInstance pattern)
     */
    viewSpanInstance(instance) {
        // Build the title like CollectionEditViewSubform.viewInstance does
        const instanceTitle = instance.title;
        const formTitle = instance.formTitle;
        let title = formTitle;
        if (instanceTitle != null && instanceTitle !== formTitle) {
            title = `${formTitle} — ${instanceTitle}`;
        }
        // Get span color (matches CollectionEditViewSubform behavior)
        const spanColor = this.readonlyCtrl.useColorCoding ? core_shared_1.FormModelFieldSubForm.getSpanColor(instance) : null;
        const borderColor = spanColor || 'transparent';
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.instance.container }, [
            // Header with span color border and title
            (0, mithril_1.m)('div', {
                title,
                className: collection_view_style_1.CSS.instance.header,
                style: { 'border-left': `6px solid ${borderColor}`, cursor: 'default' },
            }, [(0, mithril_1.m)('div', { className: collection_view_style_1.CSS.instance.text }, title)]),
            // Fields rendered in readonly mode
            collection_view_subform_1.CollectionEditViewSubform.view(this.readonlyCtrl, instance),
        ]);
    }
    validate() {
        // Validation is handled by canSubmit computed via isSubmitButtonDisabled
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // The actual result is returned via openSpanLinkModal promise
        });
    }
    close() {
        this.state.reset();
        super.close();
    }
}
exports.SpanLinkModal = SpanLinkModal;
/**
 * Opens the span link modal and returns a promise with the user's selection.
 *
 * @param sourceCollection The collection initiating the link
 * @param targetCollection The target collection to link to
 * @param sourceSpanInstanceId The ID of the span instance on the source collection
 * @returns Promise that resolves with the modal result
 */
function openSpanLinkModal(sourceCollection, targetCollection, sourceSpanInstanceId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            const state = new span_link_modal_state_1.SpanLinkModalState();
            state.initialize(sourceCollection, targetCollection, sourceSpanInstanceId);
            const modal = new SpanLinkModal({
                title: i18n_1.T.SPAN_LINK_MODAL_TITLE,
                confirm: i18n_1.T.SPAN_LINK_CONFIRM,
                success: { key: i18n_1.T.SPAN_LINK_SUCCESS },
            }, state);
            // We need to intercept the modal closing to capture the result
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            modal_service_1.ModalService.open({
                title: i18n_1.T.SPAN_LINK_MODAL_TITLE,
                content: () => modal.nodes,
                actions: () => mithril_1.m.fragment({}, [
                    (0, mithril_1.m)('button', {
                        className: 'mdl-button',
                        onclick: () => {
                            state.reset();
                            modal_service_1.ModalService.close(false);
                            resolve({ selectedSpanId: null, createNew: false, cancelled: true });
                        },
                        type: 'button',
                    }, (0, i18n_1.Translate)(i18n_1.T.CANCEL)),
                    (0, mithril_1.m)('button', {
                        className: 'mdl-button mdl-button--accent',
                        disabled: !state.canSubmit,
                        onclick: () => {
                            const result = {
                                selectedSpanId: state.selectedSpanId,
                                createNew: state.createNewSpan,
                                cancelled: false,
                            };
                            state.reset();
                            modal_service_1.ModalService.close(true);
                            resolve(result);
                        },
                        type: 'submit',
                    }, (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_CONFIRM)),
                ]),
                canClose: () => true,
            });
        });
    });
}
//# sourceMappingURL=span.link.modal.js.map